var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"inputRef",staticClass:"form-control",class:_vm.size ? `form-control-${_vm.size}` : null,attrs:{"type":"tel","placeholder":_vm.placeholder,"disabled":_vm.disabled},on:{"focus":_vm.pinCaretToEnd,"click":_vm.pinCaretToEnd,"mouseup":_vm.pinCaretToEnd,"keyup":_vm.pinCaretToEnd,"keydown":_vm.onKeydown}})
}
var staticRenderFns = []

export { render, staticRenderFns }